import { useList } from "@refinedev/core";
import { useSession } from "hooks/useSession";
import type { MediaProjectListItem } from "pages/media/types";

const COMPLETED_STATUSES = new Set(["MediaGenerated", "Published"]);

/**
 * Returns the count of completed experiences (projects with media generated or published).
 * Only fetches when `enabled` is true to avoid unnecessary API calls.
 */
export const useCompletedExperienceCount = (enabled: boolean) => {
  const { currentOrganization } = useSession();

  const { data, isLoading } = useList<MediaProjectListItem>({
    resource: `media/${currentOrganization?.id}/projects`,
    queryOptions: {
      enabled: Boolean(currentOrganization?.id) && enabled,
    },
    pagination: { pageSize: 10 },
    sorters: [{ field: "created", order: "desc" }],
  });

  const completedCount =
    data?.data.filter((p) => COMPLETED_STATUSES.has(p.status)).length ?? 0;

  // Total created projects (regardless of status) — used for "experiences left" display
  const totalCount = data?.total ?? 0;

  return { completedCount, totalCount, isLoading };
};
